/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Button, Icon, Loader, Modal } from '@scuf/common';
import { Notification } from '@scuf/common';
import './BulkUpladUserModalCommon.scss';
import i18next from 'i18next';
import { useEffect, useState } from 'react';
import useFetch from '../../commonUtils/useFetch';
import ViewData from '../../commonUtils/ViewData';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { IOrganisationState } from '../../commonUtils/Redux/Global/globalShared';
import toasts from '../../commonUtils/toasts';
import { DataTable } from '@scuf/datatable';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
const ReactToastify = require('react-toastify');
interface IDeleteAlertModal {
  onClose: () => void;
  onConfirm: () => void;
  isLoadingDeleteUser: boolean;
  authFetch: any;
  baseURL: string;
  offering: string;
  editOrgId?: string;
  organisationSelected: any;
  panelSelectedRow: any;
  setUploadUserDataSuccess: any;
}
export const ToastNotification = ({
  closeToast,
  title,
  description,
  severity,
  exiting
}: any) => (
  <Notification
    className={`toast-notification ${exiting ? 'toast-notification-exit' : ''}`}
    severity={severity}
    onCloseClick={closeToast}
    hasIcon={true}
    title={title}
  >
    {description}
  </Notification>
);
export const BulkUpladUserModal = (props: IDeleteAlertModal) => {
  const [currentFile, setCurrentFile] = useState<File | null>(null);
  const [downloadTemplateLoading, setDownloadTemplateLoading] = useState(false);
  const userProfileDetails = useSelector(
    (state: IOrganisationState) => state.globalShared.userList
  );
  const [
    uploadReportData,
    isLoadingUploadReport,
    errorUploadReport,
    fetchUploadReportData
  ] = useFetch(
    `${props.baseURL}/api/v1/bulkuserupload/orgs/${props.organisationSelected
      ?.id ?? ''}/users/${
      userProfileDetails?.id ? userProfileDetails?.id : undefined
    }/upload`,
    props.authFetch,
    undefined,
    true
  );
  const getScrollHeight = () => {
    const screenHeight = window.innerHeight;
    if (screenHeight < 500) {
      return '150px';
    }else if (screenHeight < 600) {
      return '270px';
    } else if (screenHeight < 700) {
      return '320px';
    }else if (screenHeight < 800) {
      return '420px';
    }else if(screenHeight < 1000){
      return '620px';
    } else {
      return '270px';
    }
  };
  const [scrollHeight, setScrollHeight] = useState(getScrollHeight());

  useEffect(() => {
    const handleResize = () => {
      setScrollHeight(getScrollHeight());
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const sendNewUpload = () => {
    //props.setUploadDocumentId(undefined);
    if (currentFile) {
      const postForm = new FormData();
      postForm.append('file', currentFile);
      const newOrgPostObject = {
        method: 'POST',
        body: postForm
      };
      fetchUploadReportData(newOrgPostObject);
    }
  };
  useEffect(() => {
    if (currentFile) {
      //sendNewUpload();
    }
  }, [currentFile]);

  useEffect(() => {
    if (uploadReportData) {
      if (uploadReportData.isValid) {
        props.onClose();
        props.setUploadUserDataSuccess(true);
        // notify(i18next.t('userUploadSuccess'),
        // i18next.t('userUploadProcessing'),
        //   'success');

        // toasts.success(`${i18next.t('userUploadSuccess')}\n${i18next.t('userUploadProcessing')}`);
      }
    }
  }, [uploadReportData]);

  const downloadCSV = async () => {
    if (!downloadTemplateLoading) {
      setDownloadTemplateLoading(true);
      const url = `${props.baseURL}/api/v2/excelbatches/download/template/BulkUserTemplate`;
      try {
        const response = await props.authFetch(url, props.authFetch);
        setDownloadTemplateLoading(false);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = blobUrl;
        a.download = 'BulkUserTemplate.csv';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        setDownloadTemplateLoading(false);
        console.error('There was a problem with the fetch operation:', error);
      }
    }
  };
  const renderFooterButtons = (props: any) => {
    return (
      <div className={`upload-modal-footer ${errorUploadReport?.code === 400 ? 'footerFlexEnd':'footerFlexSpaceBtw'}`}>
        <Button
          type="secondary"
          size="medium"
          content={i18next.t('cancel')}
          onClick={props.onClose}
        />
        {errorUploadReport?.code === 400 ? "" : <Button
          type="primary"
          size="medium"
          content={i18next.t('save')}
          onClick={() => sendNewUpload()}
        />}
      </div>
    );
  };
  const handleDropFile = (dragEvent: React.DragEvent<HTMLDivElement>) => {
    dragEvent.preventDefault();
    const file = dragEvent.dataTransfer.items[0].getAsFile();
    if (file) {
      setCurrentFile(file);
    }
  };
  const handleBrowseFileSelect = (
    changeEvent: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = changeEvent.currentTarget.files;
    if (files) {
      setCurrentFile(files[0]);
    }
  };

const jsonDesignForTable = (errorUploadReport: any[]) => {
 
   let val = errorUploadReport.map((item: any, index: number) => {
    return {
      index: index + 1,
      pilot: item
    };
  });
  return val;
}
  return (
    <div className="bulk-upload-user-modal">
      <Modal
        size="large"
        className="bulk-upload-user-modal-large"
        closeIcon={false}
        onClose={props.onClose}
        open={true}
        closeOnDocumentClick={false}
      >
        {errorUploadReport?.code === 400 ? <div className="bulkUpload-modal-header">
          <div className="bulkUpload-modal-subheader-title">
            {`${i18next.t('errorHeading')} (${!errorUploadReport.errorJson.isValid &&
                  errorUploadReport.errorJson.messages &&
                  errorUploadReport.errorJson.messages.length > 0 &&
                  errorUploadReport.errorJson.messages.length})`}
          </div>
        </div> :
        <div className="bulkUpload-modal-header">
          <div className="bulkUpload-modal-subheader-title">
            {i18next.t('importUsers')}
          </div>
          <div className="bulkUpload-modal-subheader">
            {i18next.t('importUsersSubHeading')}
          </div>
          <Button
            className="download-template"
            type="primary"
            size="medium"
            loading={downloadTemplateLoading}
            content={i18next.t('downloadTemplate')}
            onClick={downloadCSV}
          />
        </div>}

        <Modal.Content className="upload-modal-content">
          <div className="upload-modal-content-div">
            {errorUploadReport?.code === 400 ? (
              <div className="errorDisplay">
                <Notification severity="important">
                  <div className='notificationDivBulk'>
                  <Icon name="badge-alert" size="large" color="#ffC627" /><span>{i18next.t('errorNotification')}</span>
                  </div>
               
                </Notification>
                {!errorUploadReport.errorJson.isValid &&
                  errorUploadReport.errorJson.messages &&
                  errorUploadReport.errorJson.messages.length > 0 && (
                  <DataTable
                  className='bulkUploadErrorTable'
                    data={jsonDesignForTable(errorUploadReport.errorJson.messages)}
                    lazy={true}
                    scrollable={true}
                    scrollHeight={scrollHeight}
                  >
                    <DataTable.Column field="index" header={i18next.t('slnumber')} initialWidth="7rem"/>
                    <DataTable.Column field="pilot" header={i18next.t('errorMessageHeading')}  />
                  </DataTable>
                  )}
              </div>
            ) : (
              <div
                className={'drop-section'}
                onDragOver={e => {
                  // Required to block the default behaviour that prevents drop events
                  e.preventDefault();
                }}
                onDrop={handleDropFile}
              >
                <div className="subHeadingDocument">
                  <Icon root="common" name="document-report" size="small" />
                  {
                    <span className="browse-file-label-span">
                      {i18next.t('dropCsvHere')}{' '}
                    </span>
                  }
                  {/* This is a hidden file upload box, as to be able to upload/browse via clicking the label */}
                  <input
                    type="file"
                    id="browseFile"
                    accept=".csv"
                    style={{ display: 'none' }}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      handleBrowseFileSelect(e);
                    }}
                    value={undefined}
                  />
                  <label className="browse-file-label" htmlFor="browseFile">
                    {i18next.t('browsrForFiles')}
                  </label>
                </div>
                <div className="subHeadingBrowser">
                  {' '}
                  {i18next.t('subHeadingBrowser')}
                </div>
                <div className="subHeadingBrowserTwo">
                  {' '}
                  {i18next.t('subHeadingBrowserTwo')}
                </div>
                {currentFile && (
                  <div className="subHeadingBrowserThree">
                    {' '}
                    {`${i18next.t('fileNameDisplay')}${currentFile?.name}`}
                  </div>
                )}
                <ViewData
                  isLoading={isLoadingUploadReport}
                  isError={errorUploadReport}
                  errorRender={() => (
                    <div className="error-wrapper">
                      <div className="error-report">
                        <div className="error-icon-wrapper">
                          <Icon name="badge-warning" size="large" />
                        </div>
                        <div className="error-text">
                          {errorUploadReport ? (
                            <>
                              {errorUploadReport.code === 500 ? (
                                <div>
                                  {
                                    'Server error occurred. Please try again later.'
                                  }
                                </div>
                              ) : errorUploadReport.errorJson ? (
                                <></>
                              ) : (
                                <>
                                  {errorUploadReport.errorText
                                    ? errorUploadReport.errorText
                                    : null}
                                </>
                              )}
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  )}
                  loadingRender={() => (
                    <div className="default-loader-wrapper full-height">
                      <Loader
                        text={`${i18next.t('uploading')} ${
                          currentFile ? currentFile.name : ''
                        }...`}
                        overlayOpacity={0}
                      />
                    </div>
                  )}
                  contentRender={() => (
                    <>
                      {uploadReportData}
                      <>
                        {uploadReportData
                          ? !uploadReportData.isValid
                            ? ''
                            : ''
                          : ''}
                      </>
                    </>
                  )}
                />
              </div>
            )}
          </div>
          {renderFooterButtons(props)}
        </Modal.Content>
      </Modal>
    </div>
  );
};
